import { render, staticRenderFns } from "./CookiesIndex.vue?vue&type=template&id=560c5ab1&scoped=true&"
import script from "./CookiesIndex.vue?vue&type=script&lang=js&"
export * from "./CookiesIndex.vue?vue&type=script&lang=js&"
import style0 from "./CookiesIndex.vue?vue&type=style&index=0&id=560c5ab1&prod&lang=css&"
import style1 from "./CookiesIndex.vue?vue&type=style&index=1&id=560c5ab1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560c5ab1",
  null
  
)

export default component.exports